import { GameCenterDayLayout } from '#src/layouts/game-center/GameCenterDayLayout/index.tsx';

import type { LayoutParams } from './__generated__/routeParams.ts';

export const ScoutingCenterGamesDayLayout = () => {
  return <GameCenterDayLayout<LayoutParams> />;
};

export default ScoutingCenterGamesDayLayout;
